import React, { ReactNode, RefObject, useRef } from 'react';
import cn from 'classnames';
import type { BBCommonProps, BBEditableModeProps } from 'types/story';
import withCardTransitionContext from 'client/components/common/BuildingBlocks/BuildingBlockEnhancer';
import { ChildrenWithParentState } from 'client/components/common/BuildingBlocks/ChildrenWithParentState';
import { useShuffle } from 'client/hooks/use-shuffle';
import { getClassNames } from './constants';
import css from './Box.scss';

type Props = BBCommonProps & { children: ReactNode };

const Box: React.FC<Props> = props => {
	const ref = useRef<HTMLDivElement>(null);
	const containerRef = props.containerRef ?? ref;
	useShuffle(props);

	const renderEditable = () => {
		const editableProps = { ...props.editableModeProps?.nodeProps };
		return renderDefault(editableProps);
	};

	const renderDefault = (defaultProps: Partial<BBEditableModeProps['nodeProps']> = {}) => {
		const { nodeProps, componentProps } = props.uiConfig;
		const { boxType } = componentProps.other ?? {};

		return (
			<div
				{...nodeProps}
				{...props.stateAttrs}
				{...props.eventListeners}
				{...defaultProps}
				data-box-type={boxType}
				className={cn(
					css.box,
					nodeProps.className,
					defaultProps.className,
					getClassNames({ uiConfig: props.uiConfig })
				)}
				ref={containerRef as RefObject<HTMLDivElement>}
			>
				{props.isEditableMode ? (
					props.children
				) : (
					<ChildrenWithParentState states={props.parentStates}>
						{/* parent states can be received from parent Answer BB or parent Swipe BB */}
						{props.children}
					</ChildrenWithParentState>
				)}
			</div>
		);
	};

	return props.isEditableMode ? renderEditable() : renderDefault();
};

export default withCardTransitionContext(Box);
